module.exports = __webpack_public_path__ + "static/img/seachCompany.85c7f2dd.png";